// frontend/src/lib/activityInk.js
// The ONE table of activity inks, as tokens. It lived in TachoCalendar.jsx
// (the D:/W:/R: figures, the week header's totals, the proportion bar) and
// was lifted here (2026-09-17, the Pattern view) so the wall chart paints a
// driving segment in the SAME ink as the Day view's bar, never a second
// literal that could drift from it.
//
// Every call site is an inline style, and an inline style beats every rule
// in light-theme.css, so a literal here would be unreachable by the theme:
// on the white calendar cell the old literals measured 3.31:1 driving,
// 2.15:1 work, 3.68:1 availability and 1.94:1 rest. Each token's DARK value
// is the hex it replaced, so dark and high contrast render byte-identically.
// No wash is concatenated off this table anywhere, which is why it can be
// tokens outright and does not need the ink/colour pair the severity tables
// carry.
export const ACTIVITY_INK = {
  driving: 'var(--ink-danger)',
  work: 'var(--ink-amber)',
  availability: 'var(--ink-blue)',
  rest: 'var(--ink-green)',
  unknown: 'var(--ink-grey)',
};

/* The pattern payload's short kinds → the ink table's keys. 'nocard' has no
   ink: it is the hatch from lib/nocard.js, a texture rather than a fill. */
export const PATTERN_KIND_INK = {
  drive: ACTIVITY_INK.driving,
  work: ACTIVITY_INK.work,
  avail: ACTIVITY_INK.availability,
  rest: ACTIVITY_INK.rest,
};
